import { Values } from '../utils/types';

export const WORKSITE_TASK_STATUS = {
  CONSIDERED: 'CONSIDERED',
  PARTIALLY_CONSIDERED: 'PARTIALLY_CONSIDERED',
  NOT_CONSIDERED: 'NOT_CONSIDERED',
  IGNORED: 'IGNORED',
} as const;
export type WorksiteTaskStatus = Values<typeof WORKSITE_TASK_STATUS>;

export const FILTER_WORKSITE_TASK_STATUS = [WORKSITE_TASK_STATUS.NOT_CONSIDERED, WORKSITE_TASK_STATUS.IGNORED] as const;

export const DEFAULT_FILTER_WORKSITE_TASK_STATUS = [WORKSITE_TASK_STATUS.NOT_CONSIDERED] as const;

export const WORKSITE_CONTENT = {
  WITH_PARCELS: 'WITH_PARCELS',
  WITH_FARMHOUSES: 'WITH_FARMHOUSES',
  EMPTY: 'EMPTY',
} as const;
export type WorksiteContent = Values<typeof WORKSITE_CONTENT>;
